import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil, tap } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { CustomProduct } from '../../../product-list-page/models/custom-product.model';
import { HomePageConstants } from '../../models/homepage.model';
import { HomepageService } from '../../services/homepage.service';

@Component({
  selector: 'app-homepage-top-products-section2',
  templateUrl: './homepage-top-products-section2.component.html',
  styleUrl: './homepage-top-products-section2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HomepageTopProductsSection2Component implements OnInit, OnDestroy {

  /** Old Implementation
  protected featuredProductList: Observable<TopProductInfo>;
  public obsoleteFlag: Observable<any>;
  public quotationFlag: Observable<any>;
  public showTopProducts: boolean = false;
  protected productsListData: any[]; */

  /** OOTB Implementation */
  protected featuredProductList$: Observable<CustomProduct[]>;
  public userLoggedIn: Observable<boolean>;
  private unsubscribe$ = new Subject<void>();
  public isLoggedIn = false;

  constructor(
    private homePageService: HomepageService,
    private globalService: GlobalService,
  ) { }

  /** OOTB Implementation */
  ngOnInit(): void {
    this.loadTopFeaturedProducts();
    this.getTopFeaturedProducts();
    this.handleSubscriptions();
  }

  loadTopFeaturedProducts(): void {
    this.homePageService.loadTopFeaturedProducts();
  }

  getTopFeaturedProducts(): void {
    this.featuredProductList$ = this.homePageService.getTopFeaturedProducts();
  }

  onGetPrice(productCode: string) {
    this.homePageService.fetchProductPriceForCode(productCode);
  }

  handleSubscriptions() {
    this.userLoggedIn = this.globalService.loginBanner$;
    this.globalService.loginBanner$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.isLoggedIn = data;
      });
  }

  getProductUrl(urlVal: string): string {
    return this.globalService.getProductUrl(urlVal);
  }

  getImageUrl(imgArr): string {
    return (imgArr?.length > 0 && imgArr?.at(0)?.url)
      ? environment.siteUrls.getBackofficeUrl + imgArr.at(0).url
      : HomePageConstants.IMAGE_URL;
  }

  getUpdatedMinQty(minQuantity, interval): number {
    return this.globalService.getUpdatedMinQty(minQuantity, interval);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
    this.globalService.clearMessagesOnDestroy();
  }

  /** Old Implementation
  ngOnInit(): void {
    this.globalService.loadingSubject.next(true);
    this.getProductsList();
    this.showTopProducts = false;
    this.handleSubscriptions();
  }

  handleSubscriptions() {
    this.userLoggedIn = this.globalService.loginBanner$;
    this.globalService.topCategories$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.getProductsList();
      });
    this.globalService.loginBanner$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.isLoggedIn = data;
      });
  }

  getProductsList() {
    this.globalService.loadingSubject.next(true);
    this.homePageService.getFeaturedProductList()
    this.featuredProductList = this.homePageService.featuredProduct$.pipe(
      tap(data => {
        if (data && data.products.length > 0) {
          this.productsListData = data?.products;
          this.showTopProducts = true;
        } else {
          this.showTopProducts = false;
        }
        this.globalService.loadingSubject.next(false);
      })
    );
  }

  getProductUrl(urlVal: string): string {
    return this.globalService.getProductUrl(urlVal);
  }

  getImageUrl(imgArr: Image[]) {
    return (imgArr?.length > 0 && imgArr?.at(0)?.url)
      ? environment.siteUrls.getBackofficeUrl + imgArr.at(0).url
      : "../../../../assets/images_and_icons/image1.jpg";
  }

  addToCart(event) {
    let index = event.index;
    let paramsObject = {
      code: this.productsListData[index]?.code,
      quantity: event.quantity
    }
    let requestObject = {
      product: {
        code: this.productsListData[index]?.code,
      },
      quantity: event.quantity
    }
    let cartId = this.storageService.cartId;
    this.globalService.loadingSubject.next(true);
    this.globalService.addToCart(cartId, paramsObject, requestObject)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (success: any) => {
          this.globalService.getCartsListByLegalEntity();
          timer(1500)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(data => this.homePageService.getFeaturedProductList());
        }, error: (error: any) => {
          this.globalService.loadingSubject.next(false);
        }
      });
  }

  getUpdatedMinQty(minQuantity, interval) {
    return this.globalService.getUpdatedMinQty(minQuantity, interval);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
    this.globalService.clearMessagesOnDestroy();
  } */
}
